<div class="row">

  <h1 (click)="collapseShareClass.toggle()"
    [attr.aria-expanded]="!isSectionShareClassCollapsed"
    aria-controls="shareClass">
    Categorie A
  </h1>
  <div class="text-center" style="bottom: 10px; width: 100%;">
    <button (click)="collapseShareClass.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
      style="">
      @if (isSectionShareClassCollapsed) {
        <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
      }
      @if (!isSectionShareClassCollapsed) {
        <span><i class="fas fa-angle-double-up"></i> Réduire</span>
      }
    </button>
  </div>
  <div #collapseShareClass="ngbCollapse" [(ngbCollapse)]="isSectionShareClassCollapsed">

    <h2 (click)="collapseShareClassTable.toggle()"
      [attr.aria-expanded]="!isSectionShareClassTableCollapsed"
      aria-controls="shareClassTable">
      Tableau résumé des actions en circulation pour cette catégorie
    </h2>
    <div class="text-center" style="bottom: 10px; width: 100%;">
      <button (click)="collapseShareClassTable.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
        style="">
        @if (isSectionShareClassTableCollapsed) {
          <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
        }
        @if (!isSectionShareClassTableCollapsed) {
          <span><i class="fas fa-angle-double-up"></i> Réduire</span>
        }
      </button>
    </div>
    <div #collapseShareClassTable="ngbCollapse" [(ngbCollapse)]="isSectionShareClassTableCollapsed">
      <table class="table">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Nombre d’actions</th>
            <th scope="col">Capital versé fiscal</th>
            <th scope="col">Prix de base rajusté</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Actions en circulation avant l’émission</th>
            <td [id]="'options.shareClasses[' + this.index + '].numberOfSharesBeforeShareIssuance'">{{ shareClassOptions.numberOfSharesBeforeShareIssuance }}</td>
            <td [id]="'options.shareClasses[' + this.index + '].initialPaidUpCapital'">{{ shareClassOptions.initialPaidUpCapital | currencyCents }}</td>
            <td [id]="'options.shareClasses[' + this.index + '].initialAdjustedCostBase'">{{ shareClassOptions.initialAdjustedCostBase | currencyCents }}</td>
          </tr>
          <tr>
            <th scope="row">Actions émises</th>
            <td [id]="'options.shareClasses[' + this.index + '].numberOfSharesIssued'">{{ shareClassOptions.numberOfSharesIssued }}</td>
            <td [id]="'options.shareClasses[' + this.index + '].increasePaidUpCapitalDueToShareIssuance'">{{ shareClassOptions.increasePaidUpCapitalDueToShareIssuance | currencyCents }}</td>
            <td [id]="'options.shareClasses[' + this.index + '].adjustedCostBase'">{{ shareClassResults.adjustedCostBase | currencyCents }}</td>
          </tr>
          <tr>
            <th scope="row">Actions en circulation après l’émission</th>
            <td [id]="'options.shareClasses[' + this.index + '].totalNumberOfShares'">{{ shareClassResults.totalNumberOfShares }}</td>
            <td [id]="'options.shareClasses[' + this.index + '].totalPaidUpCapital'">{{ shareClassResults.totalPaidUpCapital | currencyCents }}</td>
            <td [id]="'options.shareClasses[' + this.index + '].totalAdjustedCostBase'">{{ shareClassResults.totalAdjustedCostBase | currencyCents }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h2 (click)="collapsePaidUpCapital.toggle()"
      [attr.aria-expanded]="!isSectionPaidUpCapitalCollapsed"
      aria-controls="paidUpCapital">
      Capital versé fiscal des actions
    </h2>
    <div class="text-center" style="bottom: 10px; width: 100%;">
      <button (click)="collapsePaidUpCapital.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
        style="">
        @if (isSectionPaidUpCapitalCollapsed) {
          <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
        }
        @if (!isSectionPaidUpCapitalCollapsed) {
          <span><i class="fas fa-angle-double-up"></i> Réduire</span>
        }
      </button>
    </div>
    <div #collapsePaidUpCapital="ngbCollapse" [(ngbCollapse)]="isSectionPaidUpCapitalCollapsed">

      <div class="card table-result-card">
        <div class="card-body">

          <div class="row">
            <div class="col-12">
              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'primary'" [text]="'ACVL'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Augmentation du capital versé
                  légal des actions de la catégorie
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div [id]="'options.shareClasses[' + this.index + '].increasePaidUpCapitalDueToShareIssuance'"
                  class="table-result-col table-result-col-value">{{ shareClassOptions.increasePaidUpCapitalDueToShareIssuance | currencyCents }}
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'primary'" [text]="'RCV'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Réduction du capital versé
                  des actions selon 84.1(1)a) L.I.R. (Voir le calcul plus bas)
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div [id]="'results.shareClasses[' + this.index + '].reducedPaidUpCapital'"
                  class="table-result-col table-result-col-value">{{ shareClassResults.reducedPaidUpCapital | currencyCents }}
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'primary'" [text]="'ACVF'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Augmentation du capital versé
                  fiscal des actions de la catégorie
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-description text-end">
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                  [text]="'ACVL'"></app-output-variable>
                  -
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                  [text]="'RCV'"></app-output-variable>
                  =
                </div>

                <div [id]="'results.shareClasses[' + this.index + '].increasePaidUpCapital'"
                  class="table-result-col table-result-col-value">{{ shareClassResults.increasePaidUpCapital | currencyCents }}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <h2 (click)="collapseReducedPaidUpCapital.toggle()"
      [attr.aria-expanded]="!isSectionReducedPaidUpCapitalCollapsed"
      aria-controls="reducedPaidUpCapital">
      Réduction du capital versé pour les actions de cette catégorie selon 84.1(1)(a) L.I.R.
    </h2>
    <div class="text-center" style="bottom: 10px; width: 100%;">
      <button (click)="collapseReducedPaidUpCapital.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"
        style="">
        @if (isSectionReducedPaidUpCapitalCollapsed) {
          <span><i
          class="fas fa-angle-double-down"></i> Agrandir</span>
        }
        @if (!isSectionReducedPaidUpCapitalCollapsed) {
          <span><i
          class="fas fa-angle-double-up"></i> Réduire</span>
        }
      </button>
    </div>
    <div #collapseReducedPaidUpCapital="ngbCollapse" [(ngbCollapse)]="isSectionReducedPaidUpCapitalCollapsed">

      <div class="card table-result-card">
        <div class="card-body">
          <div class="row">

            <div class="col-12">
              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'primary'" [text]="'ACVLT'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Augmentation du capital versé
                  légale des actions de toutes les catégories
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div [id]="'options.shareClasses[' + this.index + '].increasePaidUpCapitalDueToShareIssuance'"
                  class="table-result-col table-result-col-value">{{ shareClassOptions.increasePaidUpCapitalDueToShareIssuance | currencyCents }}
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'primary'" [text]="'B'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Élément B de 84.1(1)a)
                  L.I.R.
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-1">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'secondary'" [text]="'B1'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Le plus élevé de (i) et de
                  (ii):
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-2">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'third'" [text]="'i'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Capital versé des actions
                  vendues
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value"
                  id="options.paidUpCapitalOfGiftedShares">{{ options.paidUpCapitalOfGiftedShares | currencyCents }}
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-2">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'third'" [text]="'ii'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Prix de base rajusté modifié
                  des actions vendues
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value"
                  id="results.modifiedAdjustedCostBase">{{ results.modifiedAdjustedCostBase | currencyCents }}
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-calculation table-result-row-indent-1">
                <div class="table-result-col table-result-col-description text-end">
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                  [text]="'B1'"></app-output-variable>
                  = Max(
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'third'"
                  [text]="'i'"></app-output-variable>
                  ,
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'third'"
                  [text]="'ii'"></app-output-variable>
                  ) = Max({{ options.paidUpCapitalOfGiftedShares | currencyCents }}
                  , {{ results.modifiedAdjustedCostBase | currencyCents }}) =
                </div>
                <div class="table-result-col table-result-col-value"
                  id="results.reducedPaidUpCapitalParagraphInElementB">{{ results.reducedPaidUpCapitalParagraphInElementB | currencyCents }}
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-1">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'secondary'" [text]="'CAA'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Contrepartie autre qu’en
                  actions
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value"
                  id="options.nonShareConsideration">{{ options.nonShareConsideration | currencyCents }}
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-calculation table-result-row-indent-0">
                <div class="table-result-col table-result-col-description text-end">
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                  [text]="'B'"></app-output-variable>
                  = Max(
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                  [text]="'B1'"></app-output-variable>
                  -
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                  [text]="'CAA'"></app-output-variable>
                  , 0
                  ) = Max({{ results.reducedPaidUpCapitalParagraphInElementB | currencyCents }}
                  - {{ options.nonShareConsideration | currencyCents }} , 0) =
                </div>
                <div class="table-result-col table-result-col-value"
                  id="results.reducedPaidUpCapitalElementB">
                  {{ results.reducedPaidUpCapitalElementB | currencyCents }}
                </div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'primary'" [text]="'C'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Augmentation du capital versé
                  des actions de cette catégorie d’actions
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-value">{{ shareClassOptions.increasePaidUpCapitalDueToShareIssuance | currencyCents }}</div>
              </div>

              <div class="table-result table-result-row table-result-row-indent-0">
                <app-output-variable [selectedBadge]="selectedBadge"
                  [style]="'primary'" [text]="'RCV'"
                class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                <div class="table-result-col table-result-col-description">Réduction du capital versé
                  selon 84.1(a)a) L.I.R.
                </div>
                <div class="table-result-col table-result-col-dots"></div>
                <div class="table-result-col table-result-col-description">
                  (
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                  [text]="'ACVLT'"></app-output-variable>
                  -
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                  [text]="'B'"></app-output-variable>
                  )
                  x
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                  [text]="'C'"></app-output-variable>
                  /
                  <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                  [text]="'ACVLT'"></app-output-variable>
                  =
                </div>
                <div [id]="'results.shareClasses[' + this.index + '].increasePaidUpCapital'"
                  class="table-result-col table-result-col-value">
                  {{ shareClassResults.increasePaidUpCapital | currencyCents }}
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
